import { render, staticRenderFns } from "./PFileSelector.vue?vue&type=template&id=4cf624c8&scoped=true&"
import script from "./PFileSelector.vue?vue&type=script&lang=ts&"
export * from "./PFileSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PFileSelector.vue?vue&type=style&index=0&id=4cf624c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf624c8",
  null
  
)

export default component.exports